module.exports = __webpack_public_path__ + "img/swiper_3.5_4_3.a9fa5d97.webp";